
import React from "react";
import { STORAGE_URL } from "@/lib/supabase";
import { Logo } from "./types";

interface LogoGridProps {
  logos: Logo[] | null | undefined;
  activeLogoId: string | undefined;
  onSelectLogo: (logoId: string) => void;
}

export const LogoGrid: React.FC<LogoGridProps> = ({
  logos,
  activeLogoId,
  onSelectLogo,
}) => {
  return (
    <div className="mt-4">
      <div className="text-sm text-white/70 mb-2">Select from Existing Logos</div>
      <div className="grid grid-cols-3 gap-2">
        {logos?.map((logo) => (
          <button
            key={logo.id}
            className={`border h-[80px] rounded-md overflow-hidden flex items-center justify-center p-1 transition-all ${
              activeLogoId === logo.id
                ? "border-white/80 bg-white/20"
                : "border-white/10 bg-black hover:bg-white/10"
            }`}
            onClick={() => onSelectLogo(logo.id)}
          >
            <img
              src={`${STORAGE_URL}/storage/v1/object/public/logos/${logo.storage_path}`}
              alt={logo.filename}
              className="h-full object-contain"
            />
          </button>
        ))}
        {!logos?.length && (
          <div className="col-span-3 text-center text-white/50 py-4">
            No logos available. Upload one to get started.
          </div>
        )}
      </div>
    </div>
  );
};
